@import '../../../utils/global.module.less';

.title {
    font-size: 40px;
    font-family: LustTextMedium;
}

.header {
    width: 100%;
    border-radius: 20px;
    background-color: #f1efe9 !important;

    margin-bottom: 25px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));
}

.seperatorFields {
    margin-left: 5px;
    margin-right: 5px;
    transform: translateY(2px);
    color: #d0d5dd !important;
}
